import { resolveLinkingSurface } from './linking-surface.js';

/**
 * Claim-path analytics bag.
 *
 * WHY: `routes/agent/link/auth.tsx` used to spread `agent_id` only when
 * `agent?.embedded` was already true. The route param is the authoritative
 * identity at 401 time; waiting on a late agent fetch dropped `agent_id` on
 * every production `device_auth_invalid` row measured over 7 days. Missing
 * `is_embedded` must stay omitted — do not coerce it to false.
 *
 * Per rule: reference-rules-in-comments + code-comments-required
 * (ai.knowledge/global).
 */
export const buildClaimAnalyticsProps = (input: {
  agentId: string;
  studioId?: string;
  embedded?: boolean;
}): Record<string, unknown> => {
  return {
    agent_id: input.agentId,
    linking_surface: resolveLinkingSurface(),
    ...(input.studioId !== undefined && input.studioId !== '' ? { studio_id: input.studioId } : {}),
    ...(typeof input.embedded === 'boolean' ? { is_embedded: input.embedded } : {})
  };
};
